import React from 'react';
import { useContext } from 'react';
import AuthContext from '../../store/auth-context';

function formatAMPM(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  var strTime = hours + ':' + minutes + ' ' + ampm;
  return { fullTime: strTime, timeOfDay: ampm };
}

const AdminWrapper = ({ children }) => {
  const time = formatAMPM(new Date());
  // isLoggedIn={isLoggedIn} userDetails={userDetails}

  const context = useContext(AuthContext);

  return (
    <div className='admin custom-scroll align-items-center flex-1 flex-wrap gap-4'>
      {context.isLoggedIn ? (
        <div className='admin__additional-info'>
          <p>
            You have <span>{context.userDetails.projects.length} projects</span>
            &nbsp;and&nbsp;
            <span>
              {context.userDetails.workExperience.length} work experiences
            </span>
          </p>
          {/* <p>
            <span>Last access:</span> {time.fullTime}
          </p> */}
        </div>
      ) : (
        ''
      )}
      <div className='admin-screen'>
        <div className='trapezoid'>
          <div className='trapezoid-top'>
            <div className='trapezoid-top__text'>
              <p>
                {context.isLoggedIn
                  ? time.timeOfDay === 'am'
                    ? `GOOD MORNING: ${context.userDetails.firstName.toUpperCase()}`
                    : `GOOD AFTERNOON: ${context.userDetails.firstName.toUpperCase()}`
                  : 'WARNING: ADMIN LOGIN ONLY'}
              </p>
            </div>
          </div>
          <div className='trapezoid-right'></div>
          <div className='trapezoid-bottom'></div>
          <div className='trapezoid-left'></div>
          <div className='admin-screen__border'>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default AdminWrapper;
